<template>
  <div>
    <v-data-table
      ref="table"
      v-model="selectedValue"
      :items="items"
      :headers="headers"
      :items-per-page="-1"
      disable-sort
      disable-pagination
      hide-default-footer
      show-select
      dense
      height="200"
      :item-selected="$emit('select', selectedValue)"
    ></v-data-table>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CostDocumentSettledResult } from "@/models/api/costDocuments/CostDocumentSettledResult";
import { DataTableHeader } from "vuetify";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";

@Component
export default class CostDocumentPopupTable extends Vue {
  @Prop({ required: true })
  costDocumentSettledResult!: CostDocumentSettledResult;

  get items() {
    return this.costDocumentSettledResult.costDocumentItemPairList;
  }

  selectedValue: number[] = [];

  headers: DataTableHeader[] = [
    {
      text: filterCapitalize(i18n.t("documentNumber")),
      value: "documentNumber",
    },
    {
      text: filterCapitalize(i18n.t("item")),
      value: "name",
    },
    {
      text: filterCapitalize(i18n.t("costDiffShort")),
      value: "costDifference",
    },
  ];

  //Default select all items
  mounted() {
    const table = this.$refs.table as HTMLFormElement & Vue;
    table.toggleSelectAll(true);
  }
}
</script>

<style lang="scss"></style>
